import * as React from "react";
import { observer, inject } from "mobx-react";

import { AppStore } from "Stores/appStore";

import { Button, Modal } from "react-bootstrap";
import {useAppContext} from "@/contexts/app";


interface ModalProps {
    appStore?: AppStore
}

@inject("appStore")
@observer
export class ConfirmationModal extends React.Component<ModalProps, any> {

    handleAccept = () => {
        this.props.appStore!.confirmModal!.accept();
        this.handleClose();
    };

    handleClose = () => {
        this.props.appStore!.hideConfirmModal();
    };

    render() {
        if (!this.props.appStore) return null;
        const {confirmModal} = this.props.appStore;

        return (
            <Modal
                show={ !!confirmModal }
                onHide={this.handleClose}
                backdrop="static"
                keyboard={false}
                centered>
                <Modal.Body>
                    <div className="body">
                        <div className="alert-icon"><i className="icon icon-exclamation-circle" /></div>
                        <div className="content text-center">{ confirmModal ? confirmModal.element : "" }</div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="alert-action">
                        { confirmModal && confirmModal.showActions ?
                            <div>
                                <Button variant="secondary" onClick={ this.handleClose }>
                                    {confirmModal && confirmModal.cancelText ? confirmModal.cancelText : "Cancel"}
                                </Button>
                                <Button variant="primary" onClick={ this.handleAccept } style={{marginLeft: 15}}>
                                    {confirmModal && confirmModal.acceptText ? confirmModal.acceptText : "Yes"}
                                </Button>
                            </div> :
                            <Button variant="primary" onClick={ this.handleClose }>OK</Button>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export function ConfirmationModalFn() {
    const {confirmModal, hideConfirmModal} = useAppContext();
    const handleAccept = () => {
        confirmModal!.accept();
        handleClose();
    };
    const handleClose = () => {
        hideConfirmModal();
    };
    return (
        <Modal
            show={ !!confirmModal }
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered>
            <Modal.Body>
                <div className="body">
                    <div className="alert-icon"><i className="icon icon-exclamation-circle"/></div>
                    <div className="content text-center">{confirmModal ? confirmModal.element : ""}</div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="alert-action">
                    {confirmModal && confirmModal.showActions ?
                        <div>
                            <Button variant="secondary" onClick={handleClose}>
                                {confirmModal && confirmModal.cancelText ? confirmModal.cancelText : "Cancel"}
                            </Button>
                            <Button variant="primary" onClick={handleAccept} style={{marginLeft: 15}}>
                                {confirmModal && confirmModal.acceptText ? confirmModal.acceptText : "Yes"}
                            </Button>
                        </div> :
                        <Button variant="primary" onClick={handleClose}>OK</Button>
                    }
                </div>
            </Modal.Footer>
        </Modal>
    );
}
